module.exports = __webpack_public_path__ + "img/1.1_14.2e5837c1.jpg";